/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

/* @api */
define('Magento_Payment/js/model/credit-card-validation/credit-card-data',[], function () {
    'use strict';

    return {
        creditCard: null,
        creditCardNumber: null,
        expirationMonth: null,
        expirationYear: null,
        cvvCode: null
    };
});

